import { TickOutlined as Tick24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/TickOutlined";
import { FacetComponentProps } from "../../FacetItem";
import styles from "./ColourFacet.module.scss";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export const ColourFacet = ({
  facetDetails,
  disabled,
}: FacetComponentProps) => (
  <div
    className={cx("container", {
      container__selected: facetDetails.isSelected === "true",
      disabled: disabled,
    })}
    data-test-swatch={facetDetails.label.toLowerCase()}
    data-testid="colour-facet"
  >
    <div className={styles.info}>
      <span className={cx("swatch", facetDetails.label.toLowerCase())} />

      <span>
        {facetDetails.label} ({facetDetails.qty})
      </span>
    </div>
    {facetDetails.isSelected === "true" && (
      <span className={styles.tick}>
        <Tick24PxOutlinedIcon size="medium" />
      </span>
    )}
  </div>
);
